document.addEventListener('DOMContentLoaded', function () {
  var cartDrawer = document.querySelector('cart-drawer');

  document.querySelectorAll('.bs-add-form').forEach(function (form) {
    form.addEventListener('submit', function (evt) {
      evt.preventDefault();

      var submitBtn = form.querySelector('[type="submit"]');
      if (submitBtn) submitBtn.setAttribute('disabled', 'disabled');

      var formData = new FormData(form);
      var sections = cartDrawer ? cartDrawer.dataset.section + ',cart-icon-bubble' : 'cart-icon-bubble';
      formData.append('sections_url', window.location.pathname);
      formData.append('sections', sections);

      fetch(theme.routes.cartAdd, {
        method: 'POST',
        headers: {
          Accept: 'application/javascript',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: formData
      })
        .then(function (response) {
          if (!response.ok) throw new Error(response.status);
          return response.json();
        })
        .then(function (data) {
          if (cartDrawer) {
            cartDrawer.renderContents(data, true);
          } else {
            window.location.href = theme.routes.cart;
          }
        })
        .catch(function (error) {
          console.log(error); // eslint-disable-line
          window.location.href = theme.routes.cart;
        })
        .finally(function () {
          if (submitBtn) submitBtn.removeAttribute('disabled');
        });
    });
  });

  var sections = document.querySelectorAll('.bs-section');

  sections.forEach(function (section) {
    var tabs = section.querySelectorAll('[data-bs-tab]');
    var panels = section.querySelectorAll('[data-bs-panel]');
    var panelUpdaters = {};

    function activateTab(index) {
      tabs.forEach(function (tab) {
        var isActive = parseInt(tab.getAttribute('data-index'), 10) === index;
        tab.classList.toggle('is-active', isActive);

        var accent = tab.getAttribute('data-accent-color');
        var activeText = tab.getAttribute('data-active-text-color');

        if (isActive) {
          tab.style.backgroundColor = accent;
          tab.style.color = activeText;
        } else {
          tab.style.backgroundColor = 'transparent';
          tab.style.color = accent;
        }
      });

      panels.forEach(function (panel) {
        var panelIndex = parseInt(panel.getAttribute('data-index'), 10);
        var isActive = panelIndex === index;
        panel.classList.toggle('is-active', isActive);
      });

      // Recalculate the now-visible panel's arrows once layout settles
      var updater = panelUpdaters[index];
      if (updater) {
        window.requestAnimationFrame(updater);
        setTimeout(updater, 250);
      }
    }

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var index = parseInt(tab.getAttribute('data-index'), 10);
        activateTab(index);
      });
    });

    // Set up each panel's slider + arrows
    panels.forEach(function (panel) {
      var panelIndex = parseInt(panel.getAttribute('data-index'), 10);
      var slider = panel.querySelector('[data-bs-slider]');
      var prevBtn = panel.querySelector('[data-bs-slider-prev]');
      var nextBtn = panel.querySelector('[data-bs-slider-next]');

      if (!slider) return;

      function scrollByPage(direction) {
        var amount = slider.clientWidth * 0.9 * direction;
        slider.scrollBy({ left: amount, behavior: 'smooth' });
      }

      if (nextBtn) {
        nextBtn.addEventListener('click', function () {
          scrollByPage(1);
        });
      }

      if (prevBtn) {
        prevBtn.addEventListener('click', function () {
          scrollByPage(-1);
        });
      }

      function updateArrowVisibility() {
        if (!prevBtn || !nextBtn) return;
        var maxScroll = slider.scrollWidth - slider.clientWidth - 2;

        if (maxScroll <= 0) {
          prevBtn.style.display = 'none';
          nextBtn.style.display = 'none';
          return;
        }

        prevBtn.style.display = 'flex';
        nextBtn.style.display = 'flex';
        prevBtn.style.opacity = slider.scrollLeft <= 0 ? '0.35' : '1';
        prevBtn.style.pointerEvents = slider.scrollLeft <= 0 ? 'none' : 'auto';
        nextBtn.style.opacity = slider.scrollLeft >= maxScroll ? '0.35' : '1';
        nextBtn.style.pointerEvents = slider.scrollLeft >= maxScroll ? 'none' : 'auto';
      }

      slider.addEventListener('scroll', updateArrowVisibility);
      window.addEventListener('resize', updateArrowVisibility);
      panelUpdaters[panelIndex] = updateArrowVisibility;

      updateArrowVisibility();
      window.requestAnimationFrame(updateArrowVisibility);
      setTimeout(updateArrowVisibility, 300);
    });

    activateTab(0);
  });
});